import { fetchConfig, debounce } from '../global/global.js';

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener('modalClosed', () => {
                setTimeout(() => { this.cart.renderContents(response) });
              }, { once: true });
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

class VariantLabel extends HTMLElement {
  constructor() {
    super();
    this.legend = this.querySelector('legend');
    this.legendVariant = this.legend.firstElementChild;
    this.optionPosition = Number(this.getAttribute('data-option-position'));
    this.variantParent = this.closest('variant-radios') || this.closest('variant-selects') || null;
    this.variants;

    if(this.variantParent) {
      this.variants = this.variantParent.querySelectorAll('input[type="radio"]')
      if(this.variants.length === 0) this.variants = this.variantParent.querySelectorAll('select');
    }

    if(this.parentElement.hasAttribute('data-sticky-add')){
      return;
    } else {
      document.addEventListener('DOMContentLoaded', e => {
        this.markActiveVariant();
      })
    }
  }

  markActiveVariant() {
    if(!this.variants) return;
    const variantsArr = [...this.variants]

    const activeVariant = variantsArr.find(variant => variant.hasAttribute('checked')) || variantsArr[0];
    if(!activeVariant) return;


    let checker = this.parentElement.hasAttribute('data-sticky-add');

      if(this.variantParent.nodeName === 'VARIANT-RADIOS' && checker == false) {
        this.variantParent.onVariantChange(activeVariant, true, false);
      } else if (this.variantParent.nodeName === 'VARIANT-SELECTS' && checker == false) {
        this.variantParent.onVariantChange(activeVariant, true, false)
      }

  }

  updateLegendVariant(options, isStickyForm, stickyFormRef, mainFormRef) {
    if(!options) return;

    this.legendVariant.textContent = options[this.optionPosition];

    if(!isStickyForm && stickyFormRef) {
      stickyFormRef.querySelectorAll('variant-label')[this.optionPosition].querySelector('legend span').textContent = options[this.optionPosition];
    } else if(mainFormRef) {
      mainFormRef.querySelectorAll('variant-label')[this.optionPosition].querySelector('legend span').textContent = options[this.optionPosition];
    }
  }
}

customElements.define('variant-label', VariantLabel);

class StockMessage extends HTMLElement {
  constructor() {
    super();
    this.lowStockThreshold = +this.getAttribute('data-low-stock')
    this.lowStockWrapper = this.querySelector('.js-stock-message');
    this.variantsInventories;

    this.getVariantInventories();
  }

  getVariantInventories() {
    const variantsData = this.getAttribute('data-variants-inventory');
    if(!variantsData) return;
    this.variantsInventories = variantsData.split('/').map(variant => variant.split(','));
  }

  updateLowStockMessage(variantId) {

    const foundVariant = this.variantsInventories.filter(variant => Number(variant[0]) === variantId).flat();
    if(!foundVariant) return;
    const foundVariantInventory = Number(foundVariant[1]);

    if (foundVariantInventory < this.lowStockThreshold && foundVariantInventory > 0) {
      this.setAttribute('low-stock', '')
    } else {
      this.removeAttribute('low-stock')
    }
  }
}

customElements.define('stock-message', StockMessage);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', e => this.onVariantChange(e.target));

    this.isStickyForm = this.getAttribute('data-is-sticky-cart') === 'true' ? true : false;

    this.mainFormRef = document.querySelector('[data-product-details]');
    if(this.mainFormRef) this.mainFormVariantsRef = this.mainFormRef.querySelector('variant-radios') || this.mainFormRef.querySelector('variant-selects') || null;
  }

  onVariantChange(targetEl, initialLoad = false) {
    this.updateOptions();
    this.updateMasterId();
    this.updateLegend(targetEl);
    this.updateStockMessage(targetEl);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateMedia(initialLoad);
    }
  }

  updateLegend(targetEl) {
    const variantLabel = targetEl.closest('[data-select-fieldset]')?.querySelector('variant-label') || targetEl.closest('fieldset')?.querySelector('variant-label') || null;
    if(variantLabel) {
      variantLabel.updateLegendVariant(this.options, this.isStickyForm, this.stickyFormRef, this.mainFormRef);
    }
  }

  updateStockMessage(targetEl) {
    const lowStockCustomEl = targetEl.querySelector('stock-message') || targetEl.closest('section') ? targetEl.closest('section').querySelector('stock-message') : null;
    if(!lowStockCustomEl || !this.currentVariant) return;
    lowStockCustomEl.updateLowStockMessage(this.currentVariant.id);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);

    if(this.isStickyForm) {
      if(this.mainFormVariantsRef) this.mainFormVariantsRef.options = this.options;
      else return;

      const allSelects = this.mainFormVariantsRef.querySelectorAll('select');
      if(allSelects.length > 0) {
        this.mainFormVariantsRef.options.forEach((option, index) => {
          allSelects[index].value = option;
        })
        return;
      }

      const allRadiosFieldsets = this.mainFormVariantsRef.querySelectorAll('fieldset');
      if(allRadiosFieldsets.length > 0) {
        this.mainFormVariantsRef.options.forEach((option, index) => {
          allRadiosFieldsets[index].querySelectorAll('input[type="radio"]').forEach(radio => {
            radio.removeAttribute('checked');
              if(radio.value === option) radio.setAttribute('checked', '')
          })
        })
      }
    } else {
      if(this.stickyFormVariantsRef) this.stickyFormVariantsRef.options = this.options;
      else return;

      const allSelects = this.stickyFormVariantsRef.querySelectorAll('select');
      if(allSelects.length > 0) {
        this.stickyFormVariantsRef.options.forEach((option, index) => {
          allSelects[index].value = option;
        })
      }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });

    if(!this.isStickyForm) {
      if(this.stickyFormVariantsRef) this.stickyFormVariantsRef.currentVariant = this.currentVariant;
    } else {
      this.mainFormVariantsRef.currentVariant = this.currentVariant;
    }
  }

  updateMedia(initialLoad) {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    let mediaId = `${this.dataset.section}-${this.currentVariant.featured_media.id}`;
    let mediaGallery = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);

    if(this.isStickyForm) {
      const previewImage = this.currentVariant.featured_media.preview_image.src;
      const stickyThumbnail = document.querySelector(`.sticky-cart__thumbnail`)

      if(stickyThumbnail) {
        stickyThumbnail.src = `${previewImage}?width=60`;
        stickyThumbnail.srcset = `${previewImage}?width=60 300w`;
      }

      mediaGallery = document.querySelector('media-gallery');
      mediaId = this.mainFormVariantsRef.dataset.section + '-' + this.currentVariant.featured_media.id
    }

    const eventSetActiveMedia = new CustomEvent('setActiveMediaTrigger', {
      bubbles: true,
      detail: {
        mediaId: mediaId,
        mediaGallery: mediaGallery,
        initialLoad,
        isStickyForm: this.isStickyForm,
      }
    });

    window.addEventListener('DOMContentLoaded', () => {
      document.body.dispatchEvent(eventSetActiveMedia);
    })

    if(initialLoad) return;

    document.body.dispatchEvent(eventSetActiveMedia);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    if(this.isStickyForm) {
      if(this.stickyFormRef) this.stickyFormRef.querySelector('input[name="id"]').value = this.currentVariant.id;
    } else {
      this.mainFormRef.querySelector('[data-hidden-variant-input]').value = this.currentVariant.id;
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  checkIfSectionExists() {
    let sectionId = '';
    if(this.dataset.section === 'false') return sectionId;
    if(this.dataset.section.includes('quick-view')) return '';
    if(this.dataset.originalSection) sectionId = '&section_id=' +  this.dataset.originalSection;
    if(this.dataset.section) sectionId = '&section_id=' +  this.dataset.section;
    return sectionId;
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}${this.checkIfSectionExists()}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.productId}`);
        const source = html.getElementById(`price-${this.dataset.productId}`);
        if (source && destination) destination.innerHTML = source.innerHTML;

        const popupImage = document.querySelector('product-popup .popup-product-img-js');
        if(popupImage && this.currentVariant.featured_image) {
          popupImage.src = this.currentVariant.featured_image.src;
          popupImage.srcset = this.currentVariant.featured_image.src;
        }

        const price = document.getElementById(`price-${this.dataset.productId}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    let addBtnSticky;
    let addBtnTextSticky;
    let addBtnMain;
    let addBtnTextMain;

    if(this.isStickyForm && this.mainFormRef) {
      addBtnMain = this.mainFormRef.querySelector('[name="add"]');
      addBtnTextMain = this.mainFormRef.querySelector('[name="add"] > span');
    } else if(this.stickyFormRef) {
      addBtnSticky = this.stickyFormRef.querySelector('[name="add"]');
      addBtnTextSticky = addBtnSticky.querySelector('[name="add"] > span');
    }

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;

      if(addBtnMain) addBtnMain.setAttribute('disabled', 'disabled');
      if(text && addBtnTextMain) addBtnTextMain.textContent = text;

      if(addBtnSticky) addBtnSticky.setAttribute('disabled', 'disabled');
      if(text && addBtnTextSticky) addBtnTextSticky.textContent = text;

    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;

      if(addBtnMain) addBtnMain.removeAttribute('disabled');
      if(addBtnTextMain) addBtnTextMain.textContent = window.variantStrings.addToCart;

      if(addBtnSticky) addBtnSticky.removeAttribute('disabled');
      if(addBtnTextSticky) addBtnTextSticky.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');

    let addBtnSticky;
    let addBtnTextSticky;
    let addBtnMain;
    let addBtnTextMain;

    if(this.isStickyForm) {
      addBtnMain = this.mainFormRef.querySelector('[name="add"]');
      addBtnTextMain = this.mainFormRef.querySelector('[name="add"] > span');
      addBtnTextMain.textContent = window.variantStrings.unavailable;
    } else if(this.stickyFormRef) {
      addBtnSticky = this.stickyFormRef.querySelector('[name="add"]');
      addBtnTextSticky = addBtnSticky.querySelector('[name="add"] > span');
      addBtnTextSticky.textContent = window.variantStrings.unavailable;
    }
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);
class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });

    if(this.isStickyForm) {
      return;
    } else {
      if(this.stickyFormVariantsRef) {
        this.stickyFormVariantsRef.options = this.options;
      const allSelects = this.stickyFormVariantsRef.querySelectorAll('select');
        if(allSelects.length > 0) {
          this.stickyFormVariantsRef.options.forEach((option, index) => {
            allSelects[index].value = option;
          })
        }
      }
    }
  }
}

customElements.define('variant-radios', VariantRadios);
